import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {

  transform(value: any, args?: any, field?: any, orgId?: any): any {
    if (!args) { return value; }
    const check = value.filter(it => {
      if(field == 'org'){
        return (it.name.toLowerCase().includes(args.toLowerCase()) && it._id != orgId);
      }else if(field == 'loc'){
        return (it.area.toLowerCase().includes(args.toLowerCase()) && it._id != orgId);
      } else if (field == 'materials' || field == 'accessories' || field == 'permit' || field == 'vehicle' || field == 'status') {
        if(it.name.toLowerCase() == args.toLowerCase()){
          return null;
        }else{
          return it.name.toLowerCase().includes(args.toLowerCase());
        }
      }
    });
    if (field == 'org' || field == 'loc') {
      if (check.length < 1) {
        let index = -1;
        const a = JSON.parse(JSON.stringify(value));
        a.filter((obj, i) => {
          return obj._id === orgId ? index = i : undefined;
        });
        a.splice(index, 1);
        return a;
      } else {
        return check;
      }
    } else {
      return check;
    }
  }

}
